import ViewGiftCard from './ViewGiftCard';
import enhance from './ViewGiftCardContainer';

export default enhance(ViewGiftCard);



// WEBPACK FOOTER //
// ./src/app/giftCard/ViewGiftCard/index.js